import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { DateTime as DT } from 'luxon';
import { useSettings } from 'context/SettingsContext';
import type { RateHistoryUser, RateUserNameItem } from './model/types';

type OffRateHistoryProps = {
    UserNameItem?: RateUserNameItem | null;
};

const OffRateHistory = ({ UserNameItem = null }: OffRateHistoryProps) => {
    const { localSettings } = useSettings();
    const { t } = useTranslation(['Rate']);
    const history = (localSettings?.RATE?.history || []) as RateHistoryUser[];

    return (
        <div className="crm-table-wrap px-3">
            <Table className="RateTable table-hover mb-0">
                <thead>
                    <tr className="bg-light">
                        <td className="head-user">{t('rateUser')}</td>
                        <td className="head-date">{t('rateDate')}</td>
                        <td className="head-rate">{t('rateValue')}</td>
                    </tr>
                </thead>
                <tbody>
                    {history.map((rate, index) => {
                        const dt = DT.fromMillis(rate?.dt || 0);
                        const curr = Number(rate?.rate || 0);
                        const yest = history[index + 1]?.rate;
                        const dynamics =
                            yest != null && Number(yest) !== 0
                                ? ((curr - Number(yest)) / Number(yest)) * 100
                                : null;

                        return (
                            <tr key={rate.dt}>
                                <td className="user">
                                    {UserNameItem ? <UserNameItem user={rate} smallMode /> : null}
                                </td>
                                <td className="date">
                                    <span className="d-block font-medium">
                                        {dt.toLocaleString(DT.DATE_MED)}
                                    </span>
                                    <span className="text-muted">
                                        {dt.toLocaleString(DT.TIME_SIMPLE)}
                                    </span>
                                </td>
                                <td className="rate">
                                    <span className="d-block font-medium">{curr.toFixed(2)}</span>
                                    {dynamics != null && (
                                        <span
                                            className={`fs-12 font-medium ${
                                                dynamics > 0 ? 'text-danger' : 'text-success'
                                            }`}
                                        >
                                            {dynamics > 0
                                                ? `+${dynamics.toFixed(2)}`
                                                : dynamics.toFixed(2)}
                                        </span>
                                    )}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        </div>
    );
};

export default OffRateHistory;
